module.exports = __webpack_public_path__ + "static/kid-55e0431785306e17a13913d0f6365afc.jpg";